import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import OnlyRegistrationOTP from '../../../Components/Common/CheckPreviousRegistration/OnlyRegistrationOTP';
import { useCheckPreviousRegistration } from '../../../Components/Common/apiEndpoints/commApiEndpoints';
import Layout from '../../../Components/Layout/Layout';
import Toaster from '../../../Components/Toaster/Toaster';
import { useExhibitorAuthContext } from '../../../Context/AuthContex/ExhibitorAuthContext';
import { EXHIBITOR_USER_SUCCESS } from '../../../Helpers/Constant';
import { httpService } from '../../../Helpers/Fetcher/axios';
import { ICompanyProfileInfoRegister } from '../../../Types/RegisterTypes';
import CompanyProfile from '../RegistrationComponents/CompanyProfile';
import ContactPerson from '../RegistrationComponents/ContactPerson';
import PortalLogin from '../RegistrationComponents/PortalLogin';

const ExhibitorRegistration = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isToabMember = searchParams.get('isToabMember');
  const [toggleButton, setToggleButton] = useState(
    isToabMember === 'yes' ? 'yes' : 'no'
  );
  const [back, setBack] = useState(false);
  const { dispatch: authDispatch, setIsLoading } = useExhibitorAuthContext();
  const {
    mutate,
    isSuccess: otpSuccess,
    isPending,
  } = useCheckPreviousRegistration();
  const [registrationData, setRegistrationData] = useState<any>({});
  const Toast = Toaster();
  const navigate = useNavigate();

  const [memberData, setMemberData] =
    useState<ICompanyProfileInfoRegister | null>();
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    resetField,
    setValue,
    reset,
    formState: { errors },
    watch,
  } = useForm();
  useEffect(() => {
    if (errors) {
      const file1 = errors['user_fair_member_company_logo']?.message;
      if (file1) {
        Toast.fire({
          icon: 'error',
          title: `File is required`,
        });
      }
    }
  }, [errors, Toast]);
  const onSubmit = async (value: any) => {
    const { user_fair_member_confirm_password, ...data } = value || {};
    setIsLoading?.(true);
    if (data?.user_fair_member_password !== user_fair_member_confirm_password) {
      Toast.fire({
        icon: 'error',
        title: `Password does not match`,
      });
      setIsLoading?.(false);
      return;
    }
    if (data?.user_fair_member_password?.length < 8) {
      Toast.fire({
        icon: 'error',
        title: `Password must be at least 8 characters`,
      });
      setIsLoading?.(false);
      return;
    }

    if (data?.user_fair_member_password?.length > 16) {
      Toast.fire({
        icon: 'error',
        title: `Maximum password length is 16 characters`,
      });

      return;
    }

    setRegistrationData((prev: any) => ({ ...prev, ...data }));

    mutate({
      email: data?.user_fair_member_email,
      type: 'register_fair',
    });
    //its need when go otp page and need to return previous page
    setBack(true);
  };

  const handleRegistration = async (value: boolean) => {
    if (value) {
      const formData = new FormData();
      Object.keys(registrationData).forEach((key) => {
        if (typeof registrationData[key] === 'object') {
          if (registrationData[key] instanceof Blob) {
            formData.append(key, registrationData[key]);
          } else {
            formData.append(key, registrationData[key][0]);
          }
        } else {
          if (registrationData[key]) {
            formData.append(key, registrationData[key]);
          }
        }
      });

      try {
        const res = await httpService.post({
          url: `/api/auth/fair-member/register`,
          data: formData,
        });

        if (res.success) {
          Toast.fire({
            icon: 'success',
            title: `Successfully register`,
          });
          authDispatch?.({
            type: EXHIBITOR_USER_SUCCESS,
            payload: { ...(res?.data as any), token: res.token },
          });

          localStorage.setItem('toab_exibitor_token', res?.token as string);
          reset();
          setIsLoading?.(false);
          navigate('/profile');
        } else {
          Toast.fire({
            icon: 'error',
            title: res.message,
          });
        }
      } catch (error) {
        Toast.fire({
          icon: 'error',
          title: 'Something went wrong',
        });
      } finally {
        setIsLoading?.(false);
      }
    }
  };

  return (
    <Layout pathName={'Book your space'} showHeader>
      {Object?.keys(registrationData)?.length && otpSuccess && back ? (
        <OnlyRegistrationOTP
          email={registrationData?.user_fair_member_email}
          handleRegistration={handleRegistration}
          type='register_fair'
          setBack={setBack}
        />
      ) : (
        <div>
          <div className='container'>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className={
                  toggleButton === 'no' || memberData?.email
                    ? ''
                    : 'parent-register'
                }
              >
                <div
                  className={
                    toggleButton === 'no' || memberData?.email
                      ? ''
                      : 'child-register'
                  }
                >
                  <div>
                    <CompanyProfile
                      register={register}
                      setError={setError}
                      clearErrors={clearErrors}
                      setValue={setValue}
                      resetField={resetField}
                      errors={errors}
                      companyProfileReg={memberData}
                    />
                  </div>

                  <div>
                    <ContactPerson register={register} />
                  </div>
                  <div>
                    <PortalLogin
                      loading={isPending}
                      watch={watch}
                      register={register}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ExhibitorRegistration;
